import clsx from 'clsx'
import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import * as Yup from 'yup'
import '../masters/basic.css'
import httpService from '../../setup/http/httpServices'
import { Input, message } from 'antd'
import Select from 'react-select'
import { AddWebsiteLeftBreadcrum } from './AddWebsiteLeftBreadcrumb'
import { toAbsoluteUrl } from '../../_metronic/helpers'
import { ChromePicker } from 'react-color'
import rgbHex from 'rgb-hex'
import axios from 'axios'
import { log } from 'console'
import { handleFileUpload } from '../../setup/Upload/Upload'
import { set } from 'lodash'


const registrationSchema = Yup.object().shape({
  websiteURL: Yup.string()
    .required('URL is required')
    .matches(
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
      'Must be a URL'
    ),
})

interface Params {
  id: string;
}

export function AddWebsite() {
  const history: any = useHistory()
  const [loading, setLoading] = useState(false)
  const [loadingMob, setLoadingMob] = useState(false)
  const [loadingDesk, setLoadingDesk] = useState(false)
  const [fetchedDesk, setFetchedDesk] = useState(false)
  const [fetchedMob, setFetchedMob] = useState(false)
  const [deskfetchErr, setDeskFetchErr] = useState(false)
  const [mobfetchErr, setMobFetchErr] = useState(false)
  const [mobURL, setMobURL] = useState('')
  const [webURL, setWebURL] = useState('')
  const [thumbnail, setThumbnail] = useState('')
  const [thumbnailMob, setThumbnailMob] = useState('')
  const [desktopScreenshots, setDesktopScreenshots] = useState([
    toAbsoluteUrl('/media/logos/addScreenshot.png'),
  ])
  const [mobileScreenshots, setMobileScreenshots] = useState([
    toAbsoluteUrl('/media/logos/addScreenshot.png'),
  ])
  const [thumbnails, setThumbnails] = useState([
    toAbsoluteUrl('/media/logos/addScreenshot.png'),
  ])
  const [thumbnailsMob, setThumbnailsMob] = useState([
    toAbsoluteUrl('/media/logos/addScreenshot.png'),
  ])

  // Params required for getting id from url
  const params = useParams<Params>()

  const [toggleCrop, setToggleCrop] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState([new File([], '')])
  const [selectedFilesMobile, setSelectedFilesMobile] = useState([new File([], '')])
  const [selectedFilesThumb, setSelectedFilesThumb] = useState([new File([], '')])
  const [selectedFilesThumbMob, setSelectedFilesThumbMob] = useState([new File([], '')])
  const [color, setColor] = useState('#fff')
  const [mobErr, setMobErr] = useState(false)
  const [webErr, setWebErr] = useState(false)
  const [thumbErr, setThumbErr] = useState(false)
  const [thumbErrMob, setThumbErrMob] = useState(false)
  const [colorErr, setColorErr] = useState(false)
  const [fontErr, setFontErr] = useState(false)
  const [colorErr2, setColorErr2] = useState(false)
  const [show, setShow] = useState(true)
  const [manualWeb, setManualWeb] = useState(false)
  const [manualMob, setManualMob] = useState(false)
  const [fontCollection, setFontCollection] = useState([{ value: '', label: '' }])
  const [fontFamily, setFontFamily] = useState([{ value: '', label: '' }])
  const [fonts, setFonts] = useState([])
  const [colors, setColors] = useState([])
  const [pickerShow, setPickerShow] = useState(false)
  const [refetchBtn, setRefetchBtn] = useState(true)
  const [refetchCount, setRefetchCount] = useState([0, 0])
  const [DesktopSS, setDesktopSS] = useState('')
  const [MobileSS, setMobileSS] = useState('')
  const [desktopLoading, setDesktopLoading] = useState(false)
  const [mobileLoading, setMobileLoading] = useState(false)

  const [website, setWebsite] = useState<any>()

  // console.log(history.location.state)
  var initialValues = {
    websiteURL: '' || history.location.state?.website?.url,
    websiteTitle: '' || history.location.state?.website?.title,
  }
  useEffect(() => {
    if (history.location.pathname.split('/')[1] === 'editWebsite') {
      setWebsite(history.location.state.website)
      // setFonts(history.location.state.website?.FontFamily)
      const arr1 = []
      const arr2 = []
      for (const i of history.location.state.website?.FontFamily) {
        const obj = {
          value: i.collection,
          label: i.collection
        }
        arr1.push(obj)
        arr2.push(i.family)
      }
      setFontCollection(arr1)
      setFonts(arr2)
      // if (history.location.state.website.FontFamily?.length > 0 || history.location.state.website.FontFamily[0]?.collection === '') {
      //   setFontCollection(
      //     Array(history.location.state.website.FontFamily.length).fill(
      //       {
      //         value: '',
      //         label: '',
      //       }
      //     )
      //   )
      // }
      // else {
      //   setFontCollection(
      //     Array(history.location.state.website.FontFamily.length).fill(
      //       {
      //         value: 'Google Fonts',
      //         label: 'Google Fonts',
      //       }
      //     )
      //   )
      // }
      // fonts.forEach((f,i)=>{
      //   let x= [...fontCollection]
      //   x[i]={ value: 'Google Fonts', label: 'Google Fonts' }
      //   setFontCollection(x)
      // })
      // setMobURL(history.location.state.website.MobileSS[0])
      // setMobURL(history.location.state.website.MobileSS[0])
      setDesktopSS(history.location.state.website.DesktopSS)
      setMobileSS(history.location.state.website.MobileSS)
      setSelectedFilesThumb(history.location.state.website.desktopThumbnail)
      setSelectedFilesThumbMob(history.location.state.website.mobileThumbnail)
      setThumbnail(history.location.state.website.desktopThumbnail)
      setThumbnailMob(history.location.state.website.mobileThumbnail)
      setLoadingDesk(false)
      setLoadingMob(false)
      setShow(true)
      setColors(history.location.state.website.Colors)
    }
  }, [])

  const onChange = async (event: any) => {
    const d = await handleFileUpload(event, 1440, undefined, setDesktopLoading);
    console.log(d);
    setDesktopSS(d ? d : '')
    setWebErr(false)
  }

  const onChangeMobile = async (event: any) => {
    const d = await handleFileUpload(event, 450, undefined, setMobileLoading);
    console.log(d);
    setMobileSS(d ? d : '')
    setMobErr(false)
  }
  // function onChangeMobile(event: any) {
  //   setMobFetchErr(false)
  //   let file = event.target.files[0]
  //   setSelectedFilesMobile([file])
  //   var reader = new FileReader()
  //   reader.readAsDataURL(file)
  //   console.log(URL.createObjectURL(file))
  //   setMobURL(URL.createObjectURL(file))

  //   reader.onload = function () {
  //     setManualMob(true)
  //     setMobURL('')
  //     setMobileScreenshots(['' + reader.result + ''])
  //     setToggleCrop(true)
  //   }
  // }
  const onChangeThumb = async (event: any) => {
    const d = await handleFileUpload(event, 675, 1200);
    console.log(d);
    setThumbnail(d ? d : '')
  }
  const onChangeThumbMob = async (event: any) => {
    const d = await handleFileUpload(event, 400, 750);
    setThumbnailMob(d ? d : '')

  }
  function deleteImage(i) {
    setSelectedFiles([new File([], '')])
    let x = [...desktopScreenshots]
    x.splice(i, 1)
    setDesktopScreenshots(x)
  }
  function deleteImageMobile(i) {
    setSelectedFiles([new File([], '')])
    let x = [...mobileScreenshots]
    x.splice(i, 1)
    setMobileScreenshots(x)
  }

  function handleColorPick() {
    if (pickerShow) {
      console.log(colors.includes(color.toUpperCase()), color)

      let x = [...colors]
      if (!x.includes(color.toUpperCase())) {
        setColorErr2(false)
        x.push(color.toUpperCase())
        x.length >= 2 ? setColorErr(false) : setColorErr(true)
        setColors(x)
      } else {
        setColorErr2(true)
        setColorErr(false)
      }
      console.log(colors)
    }
    setPickerShow(!pickerShow)
  }
  function deleteColor(index) {
    let x = [...colors]
    x.splice(index, 1)
    setColors(x)
  }


  const deleteFont = (index: number) => {
    const updatedFonts = [...fonts];
    const updatedFontCollection = [...fontCollection];

    updatedFonts.splice(index, 1);
    updatedFontCollection.splice(index, 1);

    setFonts(updatedFonts);
    setFontCollection(updatedFontCollection);
  };




  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: registrationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log('here');

      if (!DesktopSS) {
        setWebErr(true)
      } else if (!MobileSS) {
        setMobErr(true)
      } else if (colors.length < 2) {
        setColorErr(true)
      }
      // else if (fonts[0].length === 0) {
      //   setFontErr(true)
      // }
      // else if (!thumbnail) {
      //   setThumbErr(true)
      // } else if (!thumbnailMob) {
      //   setThumbErrMob(true)
      // }
      else {
        setWebErr(false)
        setMobErr(false)
        setThumbErr(false)
        setThumbErrMob(false)
        setColorErr(false)
        setFontErr(false)
        setLoading(true)
        console.log('idhar')
        console.log(
          values,
          DesktopSS,
          MobileSS,
          colors,
          selectedFiles.slice(1),
          selectedFilesMobile.slice(1)
        )
        // let fd = new FormData()

        const arr = []
        for (let i = 0; i < fonts.length; i++) {
          const obj = {
            collection: fontCollection[i]?.value,
            family: fonts[i]
          }

          arr.push(obj)
        }

        console.log(arr)

        const fd = {
          url: values.websiteURL,
          title: values.websiteTitle,
          desktopThumbnail: thumbnail,
          mobileThumbnail: thumbnailMob,
          DesktopSS: DesktopSS,
          MobileSS: MobileSS,
          Colors: colors,
          FontFamily: arr

        }
        // fd.append('url', values.websiteURL)
        // fd.append('title', values.websiteTitle)
        // fd.append('desktopThumbnail', thumbnail)
        // fd.append('mobileThumbnail', thumbnailMob)
        // if (manualWeb) {
        //   fd.append('DesktopSS', selectedFiles[0])
        // } else {
        //   fd.append('autoFetchDesktop', webURL)
        // }
        // if (manualMob) {
        //   fd.append('MobileSS', selectedFilesMobile[0])
        // } else {
        //   fd.append('autoFetchMobile', mobURL)
        // }
        // colors.forEach((color) => {
        //   fd.append('Colors', color)
        // })

        // fonts.forEach((font) => {
        //   fd.append('FontFamily', font)
        // })

        setLoading(true)
        if (history.location.state?.edit) {
          httpService.patchData(
            '/website/update/?step=1',
            { ...fd, id: params.id },
            (res) => {
              console.log(res)
              setLoading(false)
              history.push({
                pathname: '/addWebsite/type',
                state: {
                  ...history.location.state,
                  id: res.data.data._id,
                  website: res.data.data,
                },
              })
            },
            (err) => {
              setLoading(false)
              console.log(err)
            }
          )
        }
        else {
          httpService.postData(
            '/website/',
            fd,
            (res) => {
              console.log(res)
              setLoading(false)
              history.push({
                pathname: '/addWebsite/type',
                state: {
                  ...history.location.state,
                  id: res.data._id,
                  // website: website,
                },
              })
            },
            (err) => {
              setLoading(false)
              console.log(err)
            }
          )
        }

      }
    },
  })

  useEffect(() => {
    console.log('websiteName', formik.values.websiteTitle);

  }, [formik.values.websiteTitle])

  useEffect(() => {
    console.log(selectedFilesThumb, selectedFilesThumbMob);

  }, [selectedFilesThumb, selectedFilesThumbMob])



  useEffect(() => {
    console.log("params", params);

  }, [])

  const [nameError, setNameError] = useState(false)

  useEffect(() => {
    if (refetchCount[0] && refetchCount[1]) setRefetchBtn(true)
  }, [refetchCount])
  useEffect(() => {
    setWebsite(website)
  }, [website])
  useEffect(() => {
    // if(fontCollection[0].value==="Google Fonts"){
    axios
      .get(
        'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyBvfBEEPr2ARh7vEhUQWJr71uKxrfHZTrQ'
      )
      .then((res) => {
        console.log(res.data.items)
        let x = [{ value: '', label: '' }]
        res.data.items.forEach((a) => {
          let y = { value: a.family, label: a.family }
          x.push(y)
        })

        setFontFamily(x)
      })
    // }
  }, [fontCollection])

  return (
    <div className='CompanyDetailsOuter'>
      <AddWebsiteLeftBreadcrum currentStep='1' />
      <form
        noValidate
        id='kt_login_signup_form'
        onSubmit={formik.handleSubmit}
        style={{ marginBottom: '100px' }}
      >
        <div className='CompanyDetails'>
          <h2 className=''>Enter Website Details</h2>
          <div className='row pt-4 pe-5 pb-5 '>
            <div className='col '>
              <h6 className='fw-bold required'>Website Name</h6>
              <Input
                type='text'
                placeholder='Enter name here...'
                className={clsx(
                  'form-control-solid rounded-4 shadow-none bg-gray-100'
                )}
                onChange={(e) => {
                  formik.setFieldValue('websiteTitle', e.target.value)
                  if (show) {
                    setRefetchBtn(false)
                  }
                }}
                value={formik.values.websiteTitle || history.location.state?.website?.[0]?.title}
                suffix={
                  <>
                    <img src={toAbsoluteUrl('/media/logos/link.svg')} alt='link' />
                  </>
                }
              />
              {/* {nameError && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text-danger' role='alert'>
                      Website URL already present.
                    </span>
                  </div>
                </div>
              )}
              {formik.errors.websiteURL && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text-danger' role='alert'>
                      {formik.errors.websiteURL}
                    </span>
                  </div>
                </div>
              )} */}
            </div>
          </div>
          <div className='row pt-4 pe-5 pb-5 '>
            <div className='col '>
              <h6 className='fw-bold required'>Website URL</h6>
              <Input
                type='text'
                placeholder='Enter URL here...'
                value={formik.values.websiteURL || history.location.state?.website?.[0].url}
                onChange={(e) => {
                  formik.setFieldValue('websiteURL', e.target.value)
                  if (show) {
                    setRefetchBtn(false)
                  }
                }}
                className={clsx(
                  'form-control-solid rounded-4 shadow-none bg-gray-100',
                  {
                    'is-invalid':
                      (formik.touched.websiteURL && formik.errors.websiteURL) || nameError,
                  },
                  {
                    'is-valid': formik.touched.websiteURL && !formik.errors.websiteURL,
                  }
                )}
                suffix={
                  <>
                    <img src={toAbsoluteUrl('/media/logos/link.svg')} alt='link' />
                  </>
                }
              />
              {nameError && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text-danger' role='alert'>
                      Website URL already present.
                    </span>
                  </div>
                </div>
              )}
              {formik.errors.websiteURL && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text-danger' role='alert'>
                      {formik.errors.websiteURL}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
          {!show && (
            <div className='d-flex pt-4 pe-5'>
              <button
                type='button'
                // id='kt_sign_up_submit'
                className='btn btn-primary CompanyDetailButton'
                // onClick={() => {
                //   console.log(formik.values.websiteURL)
                //   if (formik.values.websiteURL === '') {
                //     formik.setFieldError('websiteURL', 'URL is required')
                //   } else {
                //     setLoadingMob(true)
                //     setLoadingDesk(true)
                //     setFetchedDesk(true)
                //     setFetchedMob(true)
                //     setDeskFetchErr(false)
                //     setMobFetchErr(false)

                //     httpService.postData(
                //       '/website/url/',
                //       { url: formik.values.websiteURL, title: formik.values.websiteTitle },
                //       (res) => {
                //         console.log(res.data.data)
                //         setWebsite(res.data.data)
                //         console.log(website)

                //         // if (res.data.data.length === 0) {
                //         //   console.log('one')

                //           // httpService.postData(
                //           //   '/fetch',
                //           //   {
                //           //     uri: formik.values.websiteURL,
                //           //     type: 'desktop',
                //           //   },
                //           //   (res) => {
                //           //     setWebURL(res.data)
                //           //     console.log(res)
                //           //     setLoadingDesk(false)
                //           //     setShow(true)
                //           //   },
                //           //   (err) => {
                //           //     console.log(err)
                //           //     setLoadingDesk(false)
                //           //     setDeskFetchErr(true)
                //           //     setWebURL('')
                //           //     message.error('Invalid URL!')
                //           //   }
                //           // )
                //           // httpService.postData(
                //           //   '/fetch',
                //           //   {
                //           //     uri: formik.values.websiteURL,
                //           //     type: 'mobile',
                //           //   },
                //           //   (res) => {
                //           //     console.log(res)
                //           //     setLoadingMob(false)
                //           //     setMobURL(res.data)
                //           //     setShow(true)
                //           //   },
                //           //   (err) => {
                //           //     console.log(err)
                //           //     setLoadingMob(false)
                //           //     setMobFetchErr(true)
                //           //     setMobURL('')
                //           //     message.error('Invalid URL!')
                //           //   }
                //           // )
                //         //}
                //         if (res.data.data.length !== 0 && res.data.data[0].DesktopSS) {
                //           setColors(res.data.data[0].Colors)
                //           setFonts(res.data.data[0].FontFamily)
                //           fonts.forEach((f, i) => {
                //             let x = [...fontCollection]
                //             x[i] = { value: 'Google Fonts', label: 'Google Fonts' }
                //             setFontCollection(x)
                //           })
                //           console.log('two')
                //           setMobURL(res.data.data[0].MobileSS)
                //           setLoadingMob(false)
                //           // httpService.postData(
                //           //   '/fetch',
                //           //   {
                //           //     uri: formik.values.websiteURL,
                //           //     type: 'desktop',
                //           //   },
                //           //   (res) => {
                //           //     setWebURL(res.data)
                //           //     console.log(res)
                //           //     setLoadingDesk(false)
                //           //     setShow(true)
                //           //   },
                //           //   (err) => {
                //           //     console.log(err)
                //           //     setLoadingDesk(false)
                //           //     setDeskFetchErr(true)
                //           //     setWebURL('')
                //           //   }
                //           // )
                //         }
                //         if (res.data.data.length !== 0 && res.data.data[0].MobileSS.length === 0) {
                //           setColors(res.data.data[0].Colors)
                //           setFonts(res.data.data[0].FontFamily)
                //           fonts.forEach((f, i) => {
                //             let x = [...fontCollection]
                //             x[i] = { value: 'Google Fonts', label: 'Google Fonts' }
                //             setFontCollection(x)
                //           })
                //           console.log('three')
                //           setWebURL(res.data.data[0].DesktopSS[0])
                //           setLoadingDesk(false)
                //           // httpService.postData(
                //           //   '/fetch',
                //           //   {
                //           //     uri: formik.values.websiteURL,
                //           //     type: 'mobile',
                //           //   },
                //           //   (res) => {
                //           //     console.log(res)
                //           //     setLoadingMob(false)
                //           //     setMobURL(res.data)
                //           //     setShow(true)
                //           //   },
                //           //   (err) => {
                //           //     console.log(err)
                //           //     setLoadingMob(false)
                //           //     setMobFetchErr(true)
                //           //     setMobURL('')
                //           //   }
                //           // )
                //         }
                //         if (
                //           res.data.data.length !== 0 &&
                //           res.data.data[0].DesktopSS &&
                //           res.data.data[0].MobileSS
                //         ) {
                //           console.log('four')
                //           setFonts(res.data.data[0].FontFamily)
                //           setFontCollection(
                //             new Array(res.data.data[0].FontFamily.length).fill({
                //               value: 'Google Fonts',
                //               label: 'Google Fonts',
                //             })
                //           )
                //           // fonts.forEach((f,i)=>{
                //           //   let x= [...fontCollection]
                //           //   x[i]={ value: 'Google Fonts', label: 'Google Fonts' }
                //           //   setFontCollection(x)
                //           // })
                //           setDesktopSS(res.data.data[0].MobileSS)
                //           setMobileSS(res.data.data[0].DesktopSS)
                //           setLoadingDesk(false)
                //           setLoadingMob(false)
                //           setShow(true)
                //           setColors(res.data.data[0].Colors)
                //         }
                //       },
                //       (err) => {
                //         console.log(err)
                //         message.error(err)
                //       }
                //     )
                //   }
                // }}
                disabled={loadingMob || loadingDesk}
              >
                {!loadingMob && !loadingDesk && <span className='indicator-label'>Next</span>}
                {(loadingMob || loadingDesk) && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle'></span>
                  </span>
                )}
                {/* <span className='indicator-label'>Next</span> */}
              </button>
              <button
                type='button'
                className='btn fw-bolder btn-gray-200 CompanyDetailButton ms-5'
                onClick={() => {
                  history.push('/')
                }}
              >
                Cancel
              </button>
            </div>
          )}
        </div>
        {/* {
          show &&
          <div className="CompanyDetails" style={{ background: '#fab1a0' }}>
            <div className="pe-5">
              <div className="row">
                <h6 className='col-9 fw-bolder'>Instruction To Upload Image</h6>
                <ol className='mt-2 mb-0'>
                  <li>
                    Size limit : 10MB
                  </li>
                  <li>
                    Resolution : 400x400
                  </li>
                </ol>
              </div>
            </div>
          </div>
        } */}
        {show && (
          <div className='CompanyDetails'>
            <div className='pe-5 '>
              <div className='row mb-6'>
                <h6 className='col-9 fw-bolder'>For Desktop (webp format)</h6>

                {/* <button
                  disabled={refetchBtn || loadingDesk || loadingMob}
                  type='button'
                  className={
                    fetchedDesk && !loadingMob && !loadingDesk
                      ? 'col-3 p-0 m-0 cursor-pointer'
                      : 'col-3 p-0 m-0'
                  }
                  style={
                    !(refetchBtn || loadingDesk || loadingMob)
                      ? { textAlign: 'right', color: '#E73C3C', background: 'none', border: 'none' }
                      : { textAlign: 'right', color: 'gray', background: 'none', border: 'none' }
                  }
                  onClick={() => {
                    if (fetchedDesk && !loadingMob && !loadingDesk) {
                      setLoadingDesk(true)
                      setDeskFetchErr(false)
                      setWebURL('')
                      setManualWeb(false)
                      let x = [...refetchCount]
                      x[0] = 1
                      setRefetchCount(x)
                      httpService.postData(
                        '/fetch',
                        {
                          uri: formik.values.websiteURL,
                          type: 'desktop',
                        },
                        (res) => {
                          console.log(res)
                          setLoadingDesk(false)
                          setWebURL(res.data)
                        },
                        (err) => {
                          console.log(err)
                          setLoadingDesk(false)
                          setDeskFetchErr(true)
                          setWebURL('')
                        }
                      )
                    }
                  }}
                >
                  <img
                    src={
                      !(refetchBtn || loadingDesk || loadingMob)
                        ? toAbsoluteUrl('/media/icons/Custom/refetch.svg')
                        : toAbsoluteUrl('/media/icons/Custom/refetchdisable.svg')
                    }
                    alt='refetch'
                    className='px-3'
                  />
                  Re-Fetch Screenshot
                </button> */}
              </div>

              <div className='d-flex align-items-center justify-content-between'>
                <div className='mt-2'>
                  <h6 className='required fw-normal'>Desktop Full-page Screenshot</h6>
                  <p className='fw-normal' style={{ fontSize: '12px' }}>Desktop Screenshot Size: 1440 x variable</p>
                  {webErr && <p className='fw-normal' style={{ fontSize: '12px', color: 'red' }}>Desktop Screenshot is required</p>}
                  {/* <p
                    className='text-gray-500'
                    style={deskfetchErr ? { color: 'red' } : { color: 'green' }}
                  >
                    {!fetchedDesk && 'Click next to fetch screenshot'}
                    {loadingDesk && 'Fetching screenshot ...'}
                    {fetchedDesk &&
                      !loadingDesk &&
                      !deskfetchErr &&
                      !manualWeb &&
                      'Fetched Screenshot'}
                    {deskfetchErr && 'Fetching Failed!'}
                    {manualWeb && 'Manually Uploaded'}
                  </p> */}
                </div>
                <div>
                  <button
                    type='button'
                    className={
                      !DesktopSS
                        ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                        : 'screenshotComponentBtn'
                    }
                    disabled={!DesktopSS}
                    onClick={() => {

                      window.open(DesktopSS, '_blank')
                    }}
                  >
                    {!loadingDesk && DesktopSS && (
                      <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                    )}
                    &nbsp; Preview
                  </button>
                  {!loadingDesk && (
                    <button
                      type='button'
                      className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4'
                      disabled={loadingDesk}
                      onClick={() => {
                        document.getElementById('desktopManual').click()
                      }}
                    >
                      {/* Click to {DesktopSS ? 'Re-Uplaod' : 'Upload'} */}
                      {desktopLoading ? "Uploading..." : DesktopSS ? 'Click to Re-Uplaod' : 'Click to Upload'}
                    </button>
                  )}
                  <input
                    type='file'
                    accept='.png, .jpg, .jpeg, .svg'
                    style={{ display: 'none' }}
                    id={'desktopManual'}
                    onChange={onChange}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {show && (
          <div className='CompanyDetails'>
            <div className='pe-5 '>
              <div className='row mb-6'>
                <h6 className='col-9 fw-bolder'>For Mobile (webp format)</h6>

                {/* <button
                  disabled={refetchBtn || loadingDesk || loadingMob}
                  type='button'
                  className={
                    fetchedMob && !loadingMob && !loadingDesk
                      ? 'col-3 p-0 m-0 cursor-pointer'
                      : 'col-3 p-0 m-0'
                  }
                  style={
                    !(refetchBtn || loadingDesk || loadingMob)
                      ? { textAlign: 'right', color: '#E73C3C', background: 'none', border: 'none' }
                      : { textAlign: 'right', color: 'gray', background: 'none', border: 'none' }
                  }
                  onClick={() => {
                    if (fetchedMob && !loadingMob && !loadingDesk) {
                      setMobFetchErr(false)
                      setLoadingMob(true)
                      setMobURL('')
                      setManualMob(false)
                      let x = [...refetchCount]
                      x[1] = 1
                      setRefetchCount(x)
                      httpService.postData(
                        '/fetch',
                        {
                          uri: formik.values.websiteURL,
                          type: 'mobile',
                        },
                        (res) => {
                          console.log(res)
                          setLoadingMob(false)
                          setMobURL(res.data)
                        },
                        (err) => {
                          console.log(err)
                          setLoadingMob(false)
                          setMobFetchErr(true)
                          setMobURL('')
                        }
                      )
                    }
                  }}
                >
                  <img
                    src={
                      !(refetchBtn || loadingDesk || loadingMob)
                        ? toAbsoluteUrl('/media/icons/Custom/refetch.svg')
                        : toAbsoluteUrl('/media/icons/Custom/refetchdisable.svg')
                    }
                    alt='refetch'
                    className='px-3'
                  />
                  Re-Fetch Screenshot
                </button> */}
              </div>

              <div className='d-flex align-items-center justify-content-between'>
                <div className='mt-2'>
                  <h6 className='required fw-normal'>Mobile Full-page Screenshot (9:16)</h6>
                  <p className='fw-normal' style={{ fontSize: '12px' }}>Mobile Screenshot Size: 450 x variable</p>
                  {mobErr && <p className='fw-normal' style={{ fontSize: '12px', color: 'red' }}>Mobile Screenshot is required</p>}
                  {/* <p className='text-gray-500'>
                    {!fetchedMob && 'Click next to fetch screenshot'}
                    {loadingMob && 'Fetching screenshot ...'}
                    {fetchedMob &&
                      !loadingMob &&
                      !mobfetchErr &&
                      !manualMob &&
                      'Fetched Screenshot'}
                    {mobfetchErr && 'Fetching Failed!'}
                    {manualMob && 'Manually Uploaded'}
                  </p> */}
                </div>
                <div>
                  <button
                    type='button'
                    className={
                      !MobileSS
                        ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                        : 'screenshotComponentBtn'
                    }
                    onClick={() => {
                      // window.open(process.env.REACT_APP_API_URL.split("/api/v1")[0]+mobURL, "_blank");
                      window.open(MobileSS, '_blank')
                    }}
                    disabled={!MobileSS}
                  >
                    {!loadingMob && MobileSS && (
                      <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                    )}
                    &nbsp; Preview
                  </button>
                  {!loadingMob && (
                    <button
                      type='button'
                      className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4'
                      disabled={loadingDesk}
                      onClick={() => {
                        document.getElementById('mobileManual').click()
                      }}
                    >
                      {/* Click to {manualMob ? 'Re-Uplaod' : 'Upload'} */}
                      {mobileLoading ? "Uploading..." : manualMob ? 'Click to Re-Uplaod' : 'Click to Upload'}
                    </button>
                  )}
                  <input
                    type='file'
                    accept='.png, .jpg, .jpeg, .svg'
                    style={{ display: 'none' }}
                    id={'mobileManual'}
                    onChange={onChangeMobile}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {/* {show && (
          <div className='CompanyDetails'>
            <div className='pe-5 '>
              <div className='row mb-6'>
                <h6 className='col-9 fw-bolder'>Thumbnail Dessktop</h6>
              </div>

              <div className='d-flex align-items-center justify-content-between'>
                <div className='mt-2'>
                  <h6 className='fw-normal'>Thumbnail Desktop</h6>
                  <p className='fw-normal' style={{ fontSize: '12px' }}>Desktop Thumbnail Size: 675 x 1200</p>
                </div>
                <div>
                  <button
                    type='button'
                    className={
                      !thumbnail
                        ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                        : 'screenshotComponentBtn'
                    }
                    onClick={() => {
                      window.open(thumbnail, '_blank')
                    }}
                  >
                    <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                    &nbsp; Preview
                  </button>
                  <button
                    type='button'
                    className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4'
                    // disabled={!(fetchedDesk && !loadingDesk)}
                    onClick={() => {
                      document.getElementById('thumbManual').click()
                    }}
                  >
                    Click to Upload
                  </button>
                  <input
                    type='file'
                    accept='.png, .jpg, .jpeg, .svg'
                    style={{ display: 'none' }}
                    id={'thumbManual'}
                    onChange={onChangeThumb}
                  />
                </div>
              </div>
              {
                thumbErr &&
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text-danger' role='alert'>
                      {'Thumbnail is required'}
                    </span>
                  </div>
                </div>
              }
            </div>
          </div>
        )}
        {show && (
          <div className='CompanyDetails'>
            <div className='pe-5 '>
              <div className='row mb-6'>
                <h6 className='col-9 fw-bolder'>Thumbnail Mobile</h6>
              </div>

              <div className='d-flex align-items-center justify-content-between'>
                <div className='mt-2'>
                  <h6 className='fw-normal'>Thumbnail Mobile</h6>
                <p className='fw-normal' style={{ fontSize: '12px' }}>Mobile Thumbnail Size: 400 x 750</p>
                </div>
                <div>
                  <button
                    type='button'
                    className={
                      !thumbnailMob
                        ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                        : 'screenshotComponentBtn'
                    }
                    onClick={() => {
                      window.open(thumbnailMob, '_blank')
                    }}
                  >
                    <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                    &nbsp; Preview
                  </button>
                  <button
                    type='button'
                    className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4'
                    // disabled={!(fetchedDesk && !loadingDesk)}
                    onClick={() => {
                      document.getElementById('thumbManualMob').click()
                    }}
                  >
                    Click to Upload
                  </button>
                  <input
                    type='file'
                    accept='.png, .jpg, .jpeg, .svg'
                    style={{ display: 'none' }}
                    id={'thumbManualMob'}
                    onChange={onChangeThumbMob}
                  />
                </div>
              </div>
              {
                thumbErrMob &&
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text-danger' role='alert'>
                      {'Thumbnail is required'}
                    </span>
                  </div>
                </div>
              }
            </div>
          </div>
        )} */}

        {show && (
          <div className='CompanyDetails'>
            <h6 className='fw-bolder required'>Colors</h6>
            {colors.map((c, index) => {
              console.log(c)
              let style = {
                backgroundColor: c,
                width: '32px',
                height: '32px',
                borderRadius: '40px',
                marginBottom: '0',
              }

              return (
                <span
                  className='btn-white bg-white-100 border border-gray-300 AddColors d-inline-flex justify-content-start align-items-center my-3'
                  style={{ marginRight: '10px' }}
                >
                  <p style={style} className='border border-gray-300'></p>
                  <p style={{ marginBottom: '0', width: '80px', marginLeft: '12px' }}>{c}</p>
                  <div style={{ margin: 'auto' }}>
                    <img
                      className='cursor-pointer'
                      src={toAbsoluteUrl('/media/icons/Custom/Dustbin.svg')}
                      style={{ marginBottom: '0', marginRight: '0', marginLeft: '5%' }}
                      alt='delete'
                      onClick={() => deleteColor(index)}
                    ></img>
                  </div>
                </span>
              )
            })}

            <div className='d-flex pt-4 pe-5 pb-0 mb-0'>
              <button
                type='button'
                className='btn fw-bolder btn-gray-200 AddColors d-inline mb-0'
                style={{ background: '#F9FAFC', border: '2px solid #E5E9F2', color: '#9099A4' }}
                onClick={() => handleColorPick()}
              >
                <img
                  src={toAbsoluteUrl('/media/icons/duotune/abstract/abs011.svg')}
                  alt='add'
                  style={{
                    transform: 'rotate(90deg)',
                    width: '14px',
                    marginLeft: '-8px',
                    marginRight: '6px',
                  }}
                ></img>
                {pickerShow ? 'Choose' : colors.length ? 'Add More' : 'Add Color'}
              </button>
            </div>
            <div className='d-flex pt-4 pe-5'>
              {pickerShow && (
                <ChromePicker
                  style={{ position: 'absolute', top: '10px' }}
                  color={color}
                  onChange={(updatedColor) => {
                    console.log(updatedColor)
                    setColor(
                      '#' +
                      rgbHex(
                        updatedColor.rgb.r,
                        updatedColor.rgb.g,
                        updatedColor.rgb.b,
                        // updatedColor.rgb.a
                      )
                    )
                  }}
                />
              )}
              {colorErr && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text-danger' role='alert'>
                      {'Two colors minimum required'}
                    </span>
                  </div>
                </div>
              )}
              {colorErr2 && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text-danger' role='alert'>
                      {'Two colors cannot be same'}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {show && (
          <div className='CompanyDetails'>
            <h6 className='fw-bolder'>Font Details</h6>

            {fonts.map((font, i) => {
              return (
                <div className='row pt-4 pe-5 pb-5'>
                  <div className='col-5 '>
                    <h6 className='fw-bold required'>Select Fonts Collection</h6>
                    <Select
                      isMulti={false}
                      name='agencyAssociated'
                      placeholder='Select Fonts Collection'
                      styles={{
                        menuList: (provided, state) => ({
                          ...provided,
                          height: 'auto',
                          maxHeight: '200px',
                        }),
                      }}
                      value={fontCollection[i]}
                      options={[{ value: '', label: 'Select Font' }, { value: 'Google Fonts', label: 'Google Fonts' }, { value: 'Other', label: 'Other' }]}
                      className={clsx(
                        'form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                      )}
                      onChange={(e) => {
                        console.log(e)
                        let x = [...fontCollection]
                        x[i] = e
                        setFontCollection(x)
                      }}
                    />
                  </div>
                  <div className='col-5 '>
                    <h6 className='fw-bold required'>Select Font Family</h6>
                    {
                      fontCollection[i].value === 'Other' ?
                        <Input
                          className={'form-control-solid rounded-4 shadow-none bg-gray-100'}
                          style={{ padding: '0.65rem !important', height: '38px' }}
                          value={fonts[i]}
                          onChange={(e) => {
                            let x = [...fonts]
                            x[i] = e.target.value
                            setFonts(x)
                          }}
                        />
                        :
                        <Select
                          isMulti={false}
                          isDisabled={fontCollection[i].value === ''}
                          value={{ label: fonts[i], value: fonts[i] }}
                          name='Font Family'
                          placeholder='Select Font Family'
                          styles={{
                            menuList: (provided, state) => ({
                              ...provided,
                              height: 'auto',
                              maxHeight: '200px',
                            }),
                          }}
                          className={clsx(
                            'form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                          )}
                          options={fontFamily}
                          onChange={(e) => {
                            console.log(e)
                            let x = [...fonts]
                            x[i] = e.label
                            setFonts(x)
                          }}
                        />
                    }

                  </div>
                  <div className='col-2'>
                    {i !== 0 && ( // Check if it's not the first entry
                      <button
                        type='button'
                        className='btn fw-bolder  m-0 mt-5 mb-0'
                        onClick={() => deleteFont(i)}
                      >
                        <img
                          className='cursor-pointer'
                          src={toAbsoluteUrl('/media/icons/Custom/Dustbin.svg')}
                          style={{ marginBottom: '0', marginRight: '8px', marginLeft: '5%' }}
                          alt='delete'
                        />
                      </button>
                    )}
                  </div>


                  {fontErr && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span className='text-danger' role='alert'>
                          {'Font required'}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )
            })}

            <button
              type='button'
              // disabled={fonts[i] === ''}
              className='btn fw-bolder btn-gray-200 m-0 mt-5 mb-0'
              style={{
                background: '#F9FAFC',
                border: '2px solid #E5E9F2',
                color: '#9099A4',
                width: "180px"
              }}
              onClick={() => {
                let x = [...fonts]
                let y = [...fontCollection]
                x.push('')
                y.push({ value: '', label: '' })
                setFonts(x)
                setFontCollection(y)
              }}
            >
              <img
                src={toAbsoluteUrl('/media/icons/duotune/abstract/abs011.svg')}
                alt='add'
                style={{
                  transform: 'rotate(90deg)',
                  width: '14px',
                  marginLeft: '-8px',
                  marginRight: '6px',
                }}
              ></img>
              {fonts?.length ? "Add More" : "Add Font"}
            </button>

            {/* <div className='row pt-4 pe-5 pb-5'>
            <div className='col-5 '>
        <h6 className='fw-bold required'>Select Fonts Collection</h6>
              <Select
                isMulti={false}
                name='agencyAssociated'
                placeholder='Select Fonts Collection'
                styles={{
                  menuList: (provided, state) => ({
                    ...provided,
                    height: 'auto',
                    maxHeight:'200px'
                  }),
                }}
                options={[{ value: 'Google Fonts', label: 'Google Fonts' }]}
                className={clsx(
                  'form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                )}
                onChange={(e)=>{
                  console.log(e);
                  
                  setFontCollection(e)
                }}
              />
            </div>
            <div className='col-5 '>
            <h6 className='fw-bold required'>Select Font Family</h6>
              <Select
                isMulti={false}
                isDisabled = {fontCollection.value===""}
                name='Font Family'
                placeholder='Select Font Family'
                styles={{
                  menuList: (provided, state) => ({
                    ...provided,
                    height: 'auto',
                    maxHeight:'200px'
                  }),
                }}
                className={clsx(
                  'form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                )}
                options={fontFamily}
                onChange={(e)=>{
                  console.log(e)
                  setFonts([e.label])
                }}
              />
            </div>
            <div className='col-2'>
                <button 
                  type='button' 
                  className='btn fw-bolder btn-gray-200 m-0 mt-5 mb-0'
                  style={{background:"#F9FAFC",border: "2px solid #E5E9F2",color:"#9099A4",width:"160px"}}
                >
                  <img src={toAbsoluteUrl("/media/icons/duotune/abstract/abs011.svg")} alt="add" style={{transform:"rotate(90deg)", width:"14px", marginLeft:"-8px",marginRight:"6px"}}></img>Add Font
                </button>
            </div>
        </div> */}
          </div>
        )}

        {show && (
          <div className='d-flex pt-4 pe-5'>
            <button
              type='submit'
              id='kt_sign_up_submit'
              className='btn btn-primary ms-5 CompanyDetailButton'
              disabled={loading || mobfetchErr || deskfetchErr}
            >
              {!loading && <span className='indicator-label'>Next</span>}
              {loading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
            <Link
              to={{
                pathname: '/',
              }}
            >
              <button type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton'>
                Cancel
              </button>
            </Link>
          </div>
        )}
      </form>
    </div>
  )
}
